import { AppState } from '../../../redux'

const getDialogue = (state: AppState) => state.dialogue

export { getDialogue }
